import React, { useState } from "react";
import { FilterValue, HvFilterGroup } from "@hitachivantara/uikit-react-core";
import { useTranslation } from "react-i18next";
import { Filter, getHvFilterGroups } from "lib/utils/filterUtils";
import useStyles from "./styles";

interface WorkflowFilter {
  onChange: (value: number[][]) => void;
  filters?: number[][];
  baseFilter?: Filter[];
}

const WorkflowFilter: React.FC<WorkflowFilter> = ({
  onChange,
  filters = [],
  baseFilter = [],
}) => {
  const classes = useStyles();
  const { t } = useTranslation<string[]>(["workflow", "common"]);
  const [value, setValue] = useState<number[][]>(filters);

  /* const { data: eventTypeData } = useEventTypes({
    revalidateOnFocus: false,
  });

  const { data: actionData } = useWorkflowActions(undefined, {
    revalidateOnFocus: false,
  });

  const statusDataFilter = [
    { id: 1, name: "Active" },
    { id: 2, name: "Inactive" },
  ];

  const eventTypeDataFilter = eventTypeData?.data.map((eventType) => ({
    id: String(eventType.id),
    name: eventType.name,
  }));

  const actionDataFilter = actionData?.data.map((action) => ({
    id: String(action.pk_action_id),
    name: action.action_display_name,
  }));

  const filters = [
    {
      id: "status",
      name: t("workflow:filter.status"),
      data: statusDataFilter === undefined ? [] : statusDataFilter,
    },
    {
      id: "action",
      name: t("workflow:filter.action"),
      data: actionDataFilter === undefined ? [] : actionDataFilter,
    },
    {
      id: "eventType",
      name: t("workflow:filter.eventType"),
      data: eventTypeDataFilter === undefined ? [] : eventTypeDataFilter,
    },
  ];
*/

  const filtersData = getHvFilterGroups(baseFilter, t, "workflow:filter");

  const onChangeHandler = (event: Event, values: FilterValue) => {
    const newValues = values as number[][];
    setValue(newValues);
    onChange(newValues);
  };

  return (
    <HvFilterGroup
      id="workflowFilter"
      labels={{
        applyLabel: t("common:filter.apply"),
        cancelLabel: t("common:filter.cancel"),
        clearLabel: t("common:filter.clearFilters"),
        placeholder: t("common:filter.filters"),
        searchBoxPlaceholder: t("common:filter.search"),
        selectAll: t("common:filter.all"),
      }}
      value={value}
      filters={filtersData}
      onChange={onChangeHandler}
      className={classes.filter}
    />
  );
};

export default WorkflowFilter;
